import React, { useEffect } from "react";
import { useRef } from "react";
import { useWatch } from "react-hook-form";
import {
  BedsBathsContainer,
  PricesContainer,
  SelectContainers,
} from "./Container";
import InputSelect from "./InputSelect";

function getPropertyDetail(details, fieldID) {
  if (!details || !details.length) return;

  return details.find(({ Id }) => Id === fieldID);
}
/**
 * It generates an array (`total` length) of objects with the format { label: string, value: string }
 * @param int total
 * @param string singularPropertyName
 * @returns
 */
function generateOptions(total, propertyName) {
  return Array.from({ length: total }, (_, i) => {
    const value = i + 1;
    const label = `${value}+ ${propertyName}`;
    return { label, value };
  });
}

const minBeds = [{ label: "No min", value: "" }, ...generateOptions(10, "Bed")];
const minBaths = [
  { label: "No min", value: "" },
  ...generateOptions(10, "Bath"),
];
const PriceFields = {
  forSale: [
    { id: "minForSale", label: "Min Price" },
    { id: "maxForSale", label: "Max Price" },
  ],
  forRent: [
    { id: "minRent", label: "Min Rent" },
    { id: "maxRent", label: "Max Rent" },
  ],
};

const Selects = React.memo(
  ({ propertyDetails = [], register, control, setValue, searchType }) => {
    const [minPriceField, maxPriceField] = PriceFields[searchType];
    const minPrice = getPropertyDetail(propertyDetails, minPriceField.id) ?? [];
    const maxPrice = getPropertyDetail(propertyDetails, maxPriceField.id) ?? [];
    const initialSearchType = useRef(searchType);
    const [minPriceValue, maxPriceValue, minBedsValue, minBathsValue] =
      useWatch({
        control: control,
        name: ["minPrice", "maxPrice", "minBeds", "minBaths"],
      });

    useEffect(() => {
      if (minPriceValue === "No min") setValue("minPrice", "");
      if (maxPriceValue === "No max") setValue("maxPrice", "");
      if (minBedsValue === "No min") setValue("minBeds", "");
      if (minBathsValue === "No min") setValue("minBaths", "");
    }, [minPriceValue, maxPriceValue, minBedsValue, minBathsValue, setValue]);

    useEffect(() => {
      if (initialSearchType.current === searchType) return;
      setValue("minPrice", "");
      setValue("maxPrice", "");
    }, [searchType, setValue]);

    const { ref: refMinPrice, ...fieldMinPrice } = register("minPrice");
    const { ref: refMaxPrice, ...fieldMaxPrice } = register("maxPrice");
    const { ref: refMinBeds, ...fieldMinBeds } = register("minBeds");
    const { ref: refMinBaths, ...fieldMinBaths } = register("minBaths");

    return (
      <SelectContainers>
        <PricesContainer>
          <InputSelect
            placeholder={minPriceField.label}
            options={minPrice?.Options}
            name="minPrice"
            hasValue={Boolean(minPriceValue)}
            loading={!minPrice?.Options?.length}
            innerRef={refMinPrice}
            {...fieldMinPrice}
          />
          <span>-</span>
          <InputSelect
            placeholder={maxPriceField.label}
            options={maxPrice?.Options}
            name="maxPrice"
            hasValue={Boolean(maxPriceValue)}
            loading={!maxPrice?.Options?.length}
            innerRef={refMaxPrice}
            {...fieldMaxPrice}
          />
        </PricesContainer>
        <BedsBathsContainer>
          <InputSelect
            placeholder="Min Beds"
            options={minBeds}
            name="minBeds"
            hasValue={Boolean(minBedsValue)}
            innerRef={refMinBeds}
            {...fieldMinBeds}
          />
          <InputSelect
            placeholder="Min Baths"
            options={minBaths}
            name="minBaths"
            hasValue={Boolean(minBathsValue)}
            innerRef={refMinBaths}
            {...fieldMinBaths}
          />
        </BedsBathsContainer>
      </SelectContainers>
    );
  }
);

export default Selects;
